const RESIZE = {
    title: 'Why use Free Image Resizer?',
    list: [
        "Free Image resizer is super easy and you don't need to have any skills to use it.",
        'You can add as many images and photos as you want',
        'Support for any image format: jpeg, jpg, png, bmp, etc',
        'Support for any image resolution: landscape pictures, portrait pics, square photos.',
        'Ready presets for social media profiles: Facebook, Twitter, Instagram, YouTube, Google, Linkedin.'
    ]
};

const ROTATE = {
    title: 'Why using Free Image Rotator?',
    list: [
        `With Free Image Rotator, you can rotate as many photos as you wish. 
        There is no need to sign up or create an account. Rotate your images without any restrictions.`,

        `Rotate your images in seconds. Upload any photo to our web tool and it will rotate the picture for you.`,

        `Image Rotation Tool is completely safe to use.  
        When you upload your files, you can be sure that no one will see or get access to them. 
        We don't keep your media data anywhere.`,

        `Free Image Rotator tool provides a huge number of ready profiles and settings. 
        You can set any degree to customize the orientation of your digital pictures.`,

        `Online Image Rotator keeps the original quality of your photo after rotation.
        The tool doesn't reduce the number of pixels or squeeze the image. 
        The rotated pictures will have the same quality as the original photos.`
    ]
};

const FLIP = {
    title: 'Why use Free Image Flipper?',
    list: [
        `With Free Image Flipping tool, you can easily mirror photos and images. 
        Flip as many pics as you need. You don't have to sign up or create an account. 
        Mirror image without any limitations.`,

        `Flip image horizontally in seconds. Upload photos to our web tool and it will mirror image for you.`,

        `Image Mirroring service is completely free and safe to use. 
        We don't collect your personal data and don't save your media data anywhere.`,

        `Mirror an image with a number of ready options. To flip image horizontally, 
        simply select one of the ready profiles an let the web app do the rest of the job for you.`,

        `Online Image Flipping service saves the original image quality. The web app doesn't squeeze the photo. 
        The flipped file will have the same quality as the original picture.`
    ]
};

const CROPPER = {
    title: 'Why using Free Image Cropper?',
    list: [
        `No limitations! With Free picture cropper, you can crop as many pictures as you wish. 
        There are no restrictions. You don't need to subscribe or create an account.`,

        `Image cropping has never been so easy! You can crop photo for free literally in seconds.`,
        
        `Free Image Cropper is safe to use. No one will see or download your images. 
        Thus you can add any pictures including personal photos and pictures of documents.`,
        
        `Free Image Cropping tool is highly customizable. You can choose between automatic and manual modes. 
        The latter will let you use precise settings for your files.`,
        
        `Online Image Cropper saves the original quality of your photos. 
        You can be sure that the tool will provide the cropped picture in the same quality as the original files.`
    ]
};


export default function getContantPage(service) {
    switch (service) {
        case 'rotator': return ROTATE;
        case 'resizer': return RESIZE;
        case 'flipper': return FLIP;
        case 'cropper': return CROPPER;
        default:
            return {
                title: '',
                list: [``]
            }
    }
}
